<template>
    <v-card :loading="loading">
        <v-card-text>
            <v-row>
                <v-col cols="12" md="12">
                    <v-text-field
                    label="Año"
                    v-model="anio"
                    type="number"
                    hint="Ingresar solo números"
                    @change="getDataInstalaciones"
                ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="12">
                    <v-select
                        :items="instalaciones"
                        label="Instalaciones"
                        item-text="nombre"
                        item-value="id"
                        v-model="instalacionAsociada"
                    ></v-select>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="12">
                    <v-select
                        :items="indicadores"
                        label="Indicador Asociado"
                        item-text="nombre"
                        item-value="id"
                        v-model="indicadorAsociado"
                        @change="parametrosPorIndicador"
                    ></v-select>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="12">
                    <v-select
                        :items="parametros"
                        label="Parmetro Asociado"
                        item-text="nombre"
                        item-value="id"
                        v-model="parametroAsocido"
                    ></v-select>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" class="pt-0 pb-0">
                    <v-text-field
                        label="Detalle"
                        v-model="detalle"
                        :error-messages="detalleErrors"
                        @input="$v.detalle.$touch()"
                        @blur="$v.detalle.$touch()"
                        required
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-file-input 
                    accept=".png, .jpg, .jpeg"
                    show-size 
                    counter 
                    multiple 
                    v-model="archivos" 
                    :error-messages="docErrors"
                    @input="$v.archivos.$touch()"
                    @blur="$v.archivos.$touch()"
                    label="Agregar Evidencias">
                </v-file-input>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" :disabled="loading" text @click.native="cancelar">Cancelar</v-btn>
            <v-btn color="#0B3F67" :loading="loading" text @click="agregarIncidencia">Agregar</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
import axios from '@/axios.js';
import { required } from "vuelidate/lib/validators";

const maxFileSize = (files) => {
    if(files != null) {
        let maximo = files.length * (5 * 1024 * 1024);
        let total = 0;
        files.forEach(file => {
            total += file.size
        });        
        return total <= maximo;
    }
    return true;
}

export default{
    mounted(){
        this.getDataIndicadores();
    },
    created() {
        axios.defaults.headers.common['Authorization'] = "Bearer " + this.$store.getters.token;
    },
    
    computed:{
        detalleErrors () {
            const errors = []
            if (!this.$v.detalle.$dirty) return errors            
            !this.$v.detalle.required && errors.push('El detalle es requerido.')            
            return errors
        },
        docErrors () {
            const errors = []
            if (!this.$v.archivos.$dirty) return errors            
            !this.$v.archivos.maxFileSize && errors.push('El tamaño total debe ser menor a ' + this.fileSize + 'MB.')        
            return errors
        },
        usuario(){
            return this.$store.getters.usuario;
        },
        instalacion() {
            return this.$store.getters.sucursal;
        },
        organizacion() {
            return this.$store.getters.organizacion;
        }, 
    },

    data:() =>({
        loading: false,
        detalle: '',
        anio: 0,
        instalacionAsociada:0,
        indicadorAsociado: 0,
        parametroAsocido: 0,
        archivos:[],
        indicadores:[],
        parametros:[],
        instalaciones: []
    }),

    validations:{
        detalle:{
            required
        },
        archivos: {
            maxFileSize
        },
    },

    methods:{
        agregarIncidencia(){
            if(!this.$v.$invalid) {
            this.loading = true;
            let formData = new FormData();
            this.archivos.forEach(file => {
                formData.append('documentos', file);
            });
            formData.append("anio", this.anio);
            formData.append("detalle", this.detalle);
            formData.append("parametro", this.parametroAsocido);
            formData.append("indicador", this.indicadorAsociado);
            formData.append("usuario", this.usuario.id);
            formData.append("instalacion", this.instalacionAsociada);
            axios.post("/incidencia/agregarIncidencia/", formData).then(response =>{
                this.$store.dispatch('noti',{mensaje: 'Incidencia Reportada', color:'success'});
                this.cancelar();
            }).catch(error=>{
                if (error.request && error.request.status === 401) {
                this.$store.commit('showSessionDialog', true);
                } else {
                if (error.request && error.request.status === 415) {
                    this.$store.dispatch('noti', {mensaje: error.response.data, color: 'error'});
                    this.loading = false;
                } else {
                    this.$store.dispatch('noti',{mensaje: 'Ocurrió un error no se pudro crear la incidencia', color:'error'});
                    this.cancelar();
                    }
                }
                });
            }
        },
        cancelar(){
            this.loading = false;
            this.archivos=[];
            this.parametros=[];
            this.indicadorAsociado=[];
            this.instalaciones=[];
        },
        getDataIndicadores() {
            this.loading = true;
            axios.get('/actividadCompesacion/getDataAgregar')
            .then(response => {
                this.indicadores = response.data
            }).catch(err => {
                console.error(err);
            })
            this.loading = false
        },
        getDataInstalaciones() {
            this.loading = true;
            if(this.organizacion != null){
                axios.get("/organizacion/listarInstalacionesActivas/"+this.organizacion.id + "/" +this.anio+"/"+this.usuario.id)
                .then(response => {
                    this.instalaciones = response.data.instalaciones
                }).catch(err => {
                    console.error(err);
                })
            }
            this.loading = false
        },

        parametrosPorIndicador() {
            let indicador = this.indicadorAsociado;
            axios.get(`/categoria/listarParametrosPorIndicador/${indicador}`).then(response => {  
                this.parametros = response.data.parametros;
            }).catch(error => {
              if (error.request && error.request.status === 401) {
                this.$store.commit('showSessionDialog', true);
              } else {
                console.log( error);
              }
            })
        },
    }

}
</script>